import React, { memo, useContext } from 'react'
import { PreviewFinishPageStyles } from './Style'
import { Done } from '@mui/icons-material'
import { Button } from 'components/Form'
import { useNavigate } from 'react-router-dom'
import { app } from 'router/routes'
import { Record } from 'components'
import { PerformAssessmentContext } from './PerformAssessmentContext'
import { useSelector } from 'react-redux'
import { isEqual } from 'lodash'

const PreviewFinishPage = () => {
    const { assessment } = useSelector(state => state.assessment)
    const { blobURL } = useContext(PerformAssessmentContext)
    const navigate = useNavigate()

    const goPerformAssessments = () => navigate(app.performAssessments)

    return (
        <PreviewFinishPageStyles>
            <div className='wrap-done'>
                <Done color="white" fontSize='large' />
            </div>
            <div className='title'>
                סיימת את המבדק לדוגמא
            </div>
            <div className='description'>
                כאן תוכלי לשמוע את הקלטת המבדק.
                <div>
                    <b>
                        אחרי היציאה ההקלטה לא נשמרת במערכת.
                    </b>
                </div>
            </div>
            <div className="record">
                <div className='record-title'>
                    <b>{"מבדק לדוגמא"}</b>
                    {assessment.reading_assessment_name}
                </div>
                {blobURL && <Record hideHeader showTimeline file={blobURL} />}
            </div>
            <Button className="go-button" color="dark" action={goPerformAssessments} label="יציאה וחזרה למבדקים פעילים" />
        </PreviewFinishPageStyles>
    )
}

const isRender = (prev, next) => {
    return isEqual(prev.blobURL, next.blobURL)
}

export default memo(PreviewFinishPage, isRender)